module.exports = __webpack_public_path__ + "img/icon-fix.5a6abf97.svg";